import { useParams } from 'react-router-dom';
import ComingSoon from '../ComingSoon';
import { FileText } from 'lucide-react';

const DocumentViewer = () => {
  const { documentId } = useParams<{ documentId: string }>();

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <ComingSoon
        title="Document Viewer"
        description={`Document viewing with preview, analysis, entities, and metadata will be available soon.${documentId ? ` (Document: ${documentId})` : ''}`}
        icon={<FileText className="h-8 w-8 text-blue-600" />}
      />
    </div>
  );
};

export default DocumentViewer;
